<template>
	<div class="businessAdd">
		<div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中"    element-loading-spinner="el-icon-loading"    element-loading-background="rgba(255, 255, 255, 0.8)">
			<!-- 第一块 -->
			<div class="panelBlock">
				<div class="panelTitle"></div>
				<div class="panelContent">
          <div class="oneLine">
            <div class="label"><i class="red">*</i> 用户类型</div>
            <div class="rightInput">
              <select name="" id="" v-model="selectType">
                <option value="">请先选择用户类型</option>
                <option value="1">个人</option>
                <option value="2">公司</option>
              </select>
            </div>
          </div>
          <div class="oneLine" v-if="selectType==1">
            <div class="label"><i class="red">*</i> 个人姓名</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="name">
            </div>
          </div>
          <div class="oneLine" v-if="selectType==2">
            <div class="label"><i class="red">*</i> 公司名称</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="companyName">
            </div>
          </div>
          <div class="oneLine">
            <div class="label"><i class="red">*</i> 注册/登录手机号</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入"  v-model="phone">
            </div>
          </div>
          <div class="oneLine">
            <div class="label"><i class="red">*</i> 身份标签</div>
            <div class="rightInput">
              <input type="radio" name="idetify" value="1" v-model="type">供应商
              &nbsp;&nbsp;&nbsp;&nbsp;
              <input type="radio" name="idetify" value="2"  v-model="type">销售商
            </div>
          </div>
          <div class="oneLine">
            <div class="label">联系人姓名</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="contactName">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">联系人手机</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="contactPhone">
            </div>
          </div>
          <div class="oneLine" v-show="selectType==2">
            <div class="label">公司地址</div>
            <div class="rightInput">
              <addressSelect :proviceId="proviceId" :cityId="cityId" :distId="distId"  @changeSelect="changeAddress"></addressSelect>
              <input type="text" v-model="addressDetail" placeholder="请输入详细地址" style="padding:7px;vertical-align: top; width: 420px">
            </div>
          </div>

				</div>
			</div>
      <el-dialog  title="提交信息确认"	center	  :visible.sync="isShowModal" >
          <div class="modalWrap">

            <div class="oneLine">
              <div class="label">用户类型:</div>
              <div class="rightInput">
                <span v-if="selectType==2">公司</span>
                <span v-if="selectType==1">个人</span>
              </div>
            </div>
            <div class="oneLine" v-if="selectType==1">
              <div class="label">个人姓名:</div>
              <div class="rightInput">{{name}}</div>
            </div>
            <div class="oneLine" v-if="selectType==2">
              <div class="label">公司名称</div>
              <div class="rightInput">{{companyName}}</div>
            </div>
            <div class="oneLine">
              <div class="label">注册/登录手机号:</div>
              <div class="rightInput">{{phone}}</div>
            </div>
            <div class="oneLine">
              <div class="label">身份标签:</div>
              <div class="rightInput">
                <span v-if="type==2">销售商</span>
                <span v-if="type==1">供应商</span>
              </div>
            </div>
            <div class="oneLine">
              <div class="label">联系人姓名:</div>
              <div class="rightInput">{{contactName}}</div>
            </div>
            <div class="oneLine">
              <div class="label">联系人手机:</div>
              <div class="rightInput">{{contactPhone}}</div>
            </div>
            <div class="oneLine" v-if="selectType==2">
              <div class="label">公司地址:</div>
              <div class="rightInput">{{proviceText}}{{cityText}}{{distText}}{{addressDetail}}</div>
            </div>

          </div>
          <div class="bottomBtnLine">
            <el-button  @click="closeModal">关闭</el-button>
            <el-button type="primary" @click="submitClick" style="margin-right: 60px;">确认新增</el-button>
          </div>

      </el-dialog>

      <!-- button -->
      <div class="btnBox">
        <el-button plain @click="back">返回</el-button>
        <el-button type='primary' @click="openModal">预览</el-button>
      </div>

		</div>
	</div>
</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
  import addressSelect from '@/components/addressSelect'
	export default {
		name: 'adminIndex',
		data() {
			return {
        selectType:'',
				isLoading:false,
        isShowModal:false,
        name:'',
        phone:'',
        type:'',
        contactName:'',
        contactPhone:'',
        companyName:'',

        // ditu
        proviceText:"",
        cityText:'',
        distText:'',
        proviceId:"",
        cityId:'',
        distId:'',
        addressDetail:'',//详细地址


			}
		},
		computed: {
			IMG_PREV(){
				return api.imgPrev
			}
		},
		components: {addressSelect},
		methods: {
      changeAddress(data){
        // console.log(JSON.stringify(data))
        this.proviceId=data.proviceId
        this.proviceText=data.proviceText
        this.cityId=data.cityId
        this.cityText=data.cityText
        this.distId=data.distId
        this.distText=data.distText
      },
			back(){
				this.$router.back()
			},
      submitClick(){
        let _this=this
        let arg={
          phone:_this.phone,
          // userIndividualName:_this.name,
          // userOrganizationName:_this.companyName,
          userInitialType:_this.type,
          companyKeyPerson:_this.contactName,
          companyKeyPersonPhone:_this.contactPhone,
          userDeviceInfo:navigator.userAgent,
        }
        if(this.selectType==1){
          arg.userIndividualName=this.name
        }else if(this.selectType==2){//公司类型 多一个地址
          arg.userOrganizationName=this.companyName
          arg.userProvince=this.proviceId
          arg.company_provice=this.proviceText
          arg.userCity=this.cityId
          arg.company_city=this.cityText
          arg.userDistrict=this.distId
          arg.company_district=this.distText
          arg.userAddress=this.addressDetail
        }
        console.log(arg)
        ajaxPost('/admin/addUser', arg).then(function(res) {
          if(res.errorCode==200){
            _this.$message({
               message: "新增成功",
               type: 'success',
            });
            _this.$router.back()
          }else{
            _this.$message({
               message: res.errorMsg,
               type: 'error',
            });
          }
        }, function(res) {})

      },
      openModal(){
        let _this=this
        if(!this.selectType||!this.phone||!this.type){
          _this.$message({
             message:"带*号的为必填项",
             type: 'error',
          });
        }else if(!json.phoneReg.test(this.phone)){
          _this.$message({
             message:"登录用手机号格式不正确",
             type: 'error',
          });
        }else if(this.contactPhone&&(!json.phoneReg.test(this.contactPhone))){
          _this.$message({
             message:"联系人手机号格式不正确",
             type: 'error',
          });
        }else if(this.selectType==1){
          if(!this.name){
            _this.$message({
               message:"用户姓名为必填项",
               type: 'error',
            });
          }else{
            _this.isShowModal=true
          }

        }else if(this.selectType==2){
          if(!this.companyName){
            _this.$message({
               message:"公司名称为必填项",
               type: 'error',
            });
          }else{
            _this.isShowModal=true
          }
        }

      },
			closeModal(){
				this.isShowModal=false
			},
		},
		mounted() {
			let _this = this
		},
	}
</script>

<style scoped lang="scss">
	* {
		// outline: 1px solid blue;
	}
  .businessAdd{
    background: #fff;; padding:20px;padding-bottom:100px;
    .panelBlock{
      .panelTitle{font-weight: bold;padding:10px 0;}
      .panelContent{

      }
    }
    .btnBox{text-align: center;}
  }
  .oneLine{
    padding:10px;
    .label{display: inline-block;padding:0 20px;}
    .rightInput{display: inline-block;}
  }
  .bottomBtnLine{padding-left:30px;}

</style>



// WEBPACK FOOTER //
// src/pages/user/add.vue